import React from 'react';

type TrendType = 'up' | 'down' | 'neutral';
type ColorType = 'red' | 'yellow' | 'blue' | 'green' | 'gray';

interface StatCardProps {
  label: string;
  value: number | string;
  icon?: string;
  trend?: TrendType;
  color?: ColorType;
  className?: string;
}

const colorClasses: Record<ColorType, string> = {
  red: 'bg-gradient-to-br from-red-50 to-red-100 border-red-200',
  yellow: 'bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200',
  blue: 'bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200',
  green: 'bg-gradient-to-br from-green-50 to-green-100 border-green-200',
  gray: 'bg-gradient-to-br from-gray-50 to-gray-100 border-gray-200',
};

const trendIcons: Record<TrendType, string> = {
  up: '↗',
  down: '↘',
  neutral: '→',
};

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  icon,
  trend,
  color = 'gray',
  className = '',
}) => {
  return (
    <div
      className={`
        rounded-lg border p-4 transition-all duration-200 hover:shadow-md
        ${colorClasses[color]}
        ${className}
      `}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600">{label}</p>
          <p className="mt-1 text-3xl font-bold text-gray-900">{value}</p>
        </div>
        {icon && (
          <div className="text-4xl opacity-50 ml-2">
            {icon}
          </div>
        )}
      </div>
      {trend && (
        <div className="mt-2 flex items-center text-xs text-gray-600">
          <span className="mr-1">{trendIcons[trend]}</span>
          <span className="capitalize">{trend}</span>
        </div>
      )}
    </div>
  );
};
